import { useState, useEffect } from "react";
import { Button, Box, TextField } from "@mui/material";
import { UseIngredients } from "./UseIngredients";
import { useNavigate, useLocation } from "react-router-dom";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import useBreakpoints from "../../hooks/useBreakpoints";

function EditIngredients(props) {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const navigate = useNavigate();
  const location = useLocation();
  const [ingredient, setIngredient] = useState();
  const {
    TransferIngredient,
    validateTransfer,
    getIngredientByID,
    validate,
    updateIngredient,
  } = UseIngredients();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    if (location.state && location.state.id) {
      getIngredientByID(location.state.id, (ingredientRes) => {
        setState(ingredientRes);
      });
    }
  }, []);

  const [transferState, setTransferState] = useState({
    id: undefined,
    transferID: undefined,
  });

  const [state, setState] = useState({
    id: undefined,
    faName: undefined,
    enName: undefined,
    productCount: undefined,
  });

  const [errorState, setErrorState] = useState({
    faName: false,
    enName: false,
  });

  const [erroTransferState, setErrorTransferState] = useState({
    transferID: false,
  });

  return (
    <Detail
      breadChilds={{
        title: "اطلاعات پایه",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/ingredients" },
          { name: "ویرایش ترکیبات", url: "/ingredients/EditIngredients" },
        ],
      }}
    >
      {!ingredient ? (
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn={isSmall ? "span 12" : "span 6"}>
            <TextField
              fullWidth
              value={state.faName ? state.faName : ""}
              error={errorState.faName}
              label="نام فارسی"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, faName: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 6"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 6"}>
            <TextField
              fullWidth
              value={state.enName ? state.enName : ""}
              error={errorState.enName}
              sx={{
                input: { direction: "rtl" },
              }}
              label="نام لاتین"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, enName: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 6"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 2"}>
            <TextField
              fullWidth
              value={state.productCount ? state.productCount : ""}
              error={errorState.productCount}
              sx={{
                input: { direction: "rtl" },
              }}
              label="تعداد محصولات"
              size="small"
              variant="filled"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 10"></Box>}

          <Box
            gridColumn={isSmall ? "span 12" : "span 6"}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              sx={{ mr: 2, width: "100px" }}
              variant="contained"
              color="secondary"
              onClick={() => {
                if (validate(state, setErrorState) == 200) {
                  setProgress(true);
                  updateIngredient(state, () => {
                    navigate("/ingredients", {
                      state: { ...location.state, isBack: true },
                      replace: true,
                    });
                  });
                }
              }}
            >
              ثبت
            </Button>
            <Button
              sx={{ width: "100px" }}
              variant="outlined"
              color="secondary"
              onClick={() => {
                navigate("/ingredients", {
                  state: { ...location.state, isBack: true },
                  replace: true,
                });
              }}
            >
              بازگشت
            </Button>
          </Box>
          {!isSmall && <Box gridColumn="span 6"></Box>}

          <Box
            sx={{ display: "flex", gap: 2, alignItems: "center" }}
            gridColumn={isSmall ? "span 12" : "span 3"}
          >
            <TextField
              value={transferState.transferID ? transferState.transferID : ""}
              sx={{
                width: "60%",
                input: { direction: "rtl" },
              }}
              fullWidth
              error={erroTransferState.transferID}
              label="انتقال به کد"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setTransferState({
                  id: state.id,
                  transferID: evt.target.value,
                });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <Button
              variant="contained"
              color="secondary"
              onClick={() => {
                if (
                  validateTransfer(transferState, setErrorTransferState) == 200
                ) {
                  setProgress(true);
                  TransferIngredient(transferState, () => {
                    navigate("/ingredients", {
                      state: {
                        ...location.state,
                        isBack: true,
                      },
                      replace: true,
                    });
                  });
                }
              }}
            >
              انتقال
            </Button>
          </Box>
        </Box>
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}

export default EditIngredients;
